// extracted by mini-css-extract-plugin
export var chevronIcon = "_7i-2";
export var teamName = "_7i-1";
export var teamSwitcherButton = "_7i-0";